module.exports = __webpack_public_path__ + "static/img/jialg.ad1a21ea.png";